module.exports = {"name":"name","address":"Adresse","mobile_number":"$t(phone:mobile_number)","date_of_birth":"$t(birthdate:date_of_birth)","firstName":"Vorname","lastName":"Familien-oder Nachname","birthdate":"Geburtsdatum","maiden-name":"Birth/maiden name","nationality":"Nationality","address_hint":"Adjusted to the official format"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/flowConfirmation.json
// module id = 486
// module chunks = 248 1691